import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, } from "@angular/core";
import { AbstractControl, NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { SharedDataService, SuppliersService, DocumentsService, ContactsService } from '../../../all-services';
import { Observable, of, Subject, Subscription } from "rxjs";
import { Contact, SimpleReponseResult, Supplier, SupplierStatut } from '../../../all-models';
import { SaveStepParam } from "./SaveStepParam";
import { detailSupplierScreenValidity } from "./detailSupplierScreenValidity";
import { SupplierScreenStep } from "./SupplierScreenStep";
import { map } from "rxjs/operators";

export class checkValidityEvent {
    public stepNum!: number;
    public showerrorMessage: boolean = false;
    public forms?: NgForm[] = [];
}

@Component({
    template: ''
})
export abstract class SupplierDetailsStepBase implements OnChanges, OnInit, OnDestroy {
    //@Input() currentStep: number;



    @Input() ocurrentstep!: SupplierScreenStep;
    @Input() demandeur?: Contact;
    @Input() supplier: Supplier = new Supplier();


    constructor(
        public sharedDatasSvc: SharedDataService,
        public docsSvc: DocumentsService,
        public suppliersSvc: SuppliersService,
        public route: ActivatedRoute,
        public contactsSvc: ContactsService
    ) { }
    
    ngOnInit(): void {
       
    }

    

    public subscriptions: Subscription[] = [];

    get msgEcranIncomplet(): Observable<string> {
        return this.sharedDatasSvc.getLabel('Ecran_incomplet_pas_de_sauvegarde');
    }




    abstract onCheckValidity(event: checkValidityEvent): Observable<boolean | undefined>;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ocurrentstep'] && this.ocurrentstep) {
            this.subscriptions.push(this.ocurrentstep.saveStep.subscribe((param: SaveStepParam) => {
                param.step = this.ocurrentstep.index;
                this.save(param);
            }));
            this.subscriptions.push(this.ocurrentstep.raiseCheckValidity.subscribe({
                next: (showError?: boolean | void | undefined) => {
                    this.ocurrentstep.screenValidity.errorMessages = [];
                    let event: checkValidityEvent = new checkValidityEvent();
                    event.stepNum = this.ocurrentstep.index;
                    event.showerrorMessage = !!showError;
                    return this.onCheckValidity(event)
                        .subscribe({
                            next: (isValid: boolean | undefined) => {
                                if (isValid != undefined) {
                                    if (event.forms) {
                                        let formErrors = false;
                                        event.forms.forEach(f => {
                                            formErrors = formErrors || this.formRevealErrors(f);
                                        });
                                        if (formErrors) {
                                            isValid = false;
                                            this.ocurrentstep.screenValidity.errorMessages.push('Champs_en_erreur');
                                        }
                                    }
                                    if (!isValid && this.ocurrentstep.screenValidity.errorMessages .length==0){
                                        this.ocurrentstep.screenValidity.errorMessages.push('Champs_en_erreur');
                                    }
                                    if (this.ocurrentstep.screenValidity.isValid != isValid) this.ocurrentstep.screenValidity.isValid = isValid;
                                }
                                if (showError) {
                                   this.ocurrentstep.screenValidity.showErrors(()=>this.ocurrentstep.onValidityChecked.emit(this.ocurrentstep.screenValidity));
                                } else{
                                    this.ocurrentstep.onValidityChecked.emit(this.ocurrentstep.screenValidity);
                                }
                            }
                        });
                }
            }));
        }
    }

    ngOnDestroy() {
        while (this.subscriptions.length > 0) {
            this.subscriptions.pop().unsubscribe();
        }
    }

    get currentStep(): number {
        return this.ocurrentstep.index;
    }
    //@Output() stepSaved: EventEmitter<SaveStepParam> = new EventEmitter<SaveStepParam>();
    get stepSaved(): EventEmitter<SaveStepParam> {
        return this.ocurrentstep.stepSaved;
    }
    //@Input() readonly: boolean;
    get readonly(): boolean {
        return <boolean>this.ocurrentstep.isReadonly();
    }

    isEditing(): boolean {
        if (this.isCreatingSupplier) return true;
        return this.ocurrentstep?.isEditing;
    }

    get screenValidity(): detailSupplierScreenValidity {
        return this.ocurrentstep?.screenValidity;
    }

    // @Input() canModifySupplier: boolean = false;
    canModifySupplier(): boolean {
        return this.ocurrentstep?.canModifySupplier();
    }



    get isCreatingSupplier(): boolean {
        if (this.sharedDatasSvc.profil?.Cod == 'FOURNISSEUR') {
            //Le fournisseur pourra sauvegarder son dossier s'il est en création fournisseur, demande de complément ou référencé
            return ['100', '150'].indexOf(this.supplierStatutCod) >= 0;
        } else if (['010', '100'].indexOf(this.supplierStatutCod) >= 0) {
            //Les profils qui peuvent créer un fournisseur peuvent sauvegarder le dossier lors sa création
            return this.suppliersSvc.canCreateSupplier;
        } else {
            //return this.suppliersSvc.canValidateWFSupplier(this.supplier);
            return false;
        }
    }

    public isValid?: boolean = null;

    // public get labels(): PS_Lib_Report_Et_Form_Result[]{
    //     return this.pafLabels ? this.pafLabels.labels : [];
    // }

    public Label(lblCod: string): Observable<string> {
        return this.sharedDatasSvc.getLabel(lblCod);
    }

    //Le code statut du fournisseur conditionne l'affichage des boutons, accès aux composants etc.
    public get supplierStatut(): SupplierStatut | null {
        if (!this.supplier) {
            return null;
        } else {
            return this.suppliersSvc.lstStatut.find(s => s.Id == this.supplier.StatutId);
        }
    }
    //Le code statut du fournisseur conditionne l'affichage des boutons, accès aux composants etc.
    public get supplierStatutCod(): string {
        return this.supplierStatut?.Cod || '';
    }

    private $patchCurrentStep: Observable<Supplier> = null;
    //Methodes à surcharger dans les classes héritées
    save(param: SaveStepParam): void {
        let patchParam: Supplier = new Supplier();
        patchParam.Id = this.supplier.Id;
        switch (param.nextAction) {
            case 'next':
                patchParam.RefStep = this.supplier.RefStep + 1;
                break;
            case 'previous':
                patchParam.RefStep = this.supplier.RefStep - 1;
                break;
            case 'close':
                patchParam.RefStep = this.supplier.RefStep;
                break;
            case 'end':
                //On force l'affichage au 1er écran quand on envoie en validation ou approbation
                patchParam.RefStep = 0;
                break;
            case 'screen':
                patchParam.RefStep = param.step;
                break;
            case 'forceScreen':
                patchParam.RefStep = param.nextStep;
                break;
            default:
                this.$patchCurrentStep = of(this.supplier);
        }
        if (patchParam.RefStep == this.supplier.RefStep){
            //Il n'y a pas de changement d'onglet, inutile de patcher
            this.$patchCurrentStep = of(this.supplier);
        }
        if (!this.$patchCurrentStep) {
            this.$patchCurrentStep = this.suppliersSvc.PatchSimpleValues(this.supplier.Id, patchParam, 'NumTiers')
                .pipe(map(result => {
                    return this.supplier;
                }));
        }  

        let subscription:Subscription = this.$patchCurrentStep
        .pipe(map(result => {
            this.supplier.RefStep = patchParam.RefStep;
            return this.supplier;
        })).subscribe((supplier1: Supplier) => {
            this.addCommentIfNonEmpty(supplier1.Id, param.Comment)
                .subscribe(res => {
                    subscription.unsubscribe();
                    if (!res.Ok && res.Message) {
                        this.sharedDatasSvc.alert(res.Message);
                    } else {
                        //On recharge le fournisseur depuis la base et on le renvoie aux écrans
                        this.suppliersSvc.getSupplier(supplier1.Id)
                            .subscribe((supplier2: Supplier) => {
                                param.supplier = supplier2;
                                this.$patchCurrentStep = null;
                                this.sharedDatasSvc.WindowUnlock();
                                this.stepSaved.emit(param);
                            });
                    }
                },
                    httpError => {
                        this.sharedDatasSvc.alert(httpError.error?.Message || httpError.error || httpError);
                    });
        });
    }

    private addCommentIfNonEmpty(supplierId: number, comment: string): Observable<SimpleReponseResult> {
        // Evo 2023 (ticket 301) : commentaire vide possible mais conserver une trace de mise à jour

        // if (!comment){
        //     let retour : SimpleReponseResult=new SimpleReponseResult();
        //     retour.Ok = true;
        //     retour.Id = supplierId;
        //     return of( retour)
        // } else {
        return this.suppliersSvc.PostUpdateComment(supplierId, comment);
        //}
    }


    public alertChampsEnEreur() {
        this.sharedDatasSvc.pafAlert('Champs_en_erreur');
    }

    public CanSave(f: NgForm, param: SaveStepParam): void {
        param.canSave = true;
        this.submitShowError();// Affiche les erreurs des directives supp-contact-row
        let avecError: boolean = this.formRevealErrors(f);
        param.canSave = !(avecError);// || f.invalid);
        if (!param.canSave) {
            this.sharedDatasSvc.WindowUnlock();
            if (!param.noSaveAllowed(this.currentStep)) this.alertChampsEnEreur();
        }
    }

    public formRevealErrors(f: NgForm): boolean {
        let avecError: boolean = false;
        Object.keys(f.controls).forEach((key, i) => {
            let control: AbstractControl = f.controls[key];
            control.markAsTouched();
            if (control.errors != null) {
                if (!control.errors.intraTvaWarning) {
                    avecError = true;
                    return;
                }
            }
        });
        return avecError;// || f.invalid;
    }


    public showErrors: Subject<boolean> = new Subject();
    public submitShowError(): void {
        this.showErrors.next(true);
    }



    get InternalContactDisplayedMail(): string {
        if (!this.demandeur) return '';
        return this.demandeur?.EmailDiff || this.demandeur?.Email;
    }



    get pilotageENDELDisabled(): boolean {
        if (!this.canModifySupplier()) return true;
        return !this.sharedDatasSvc.checkProfilAccessPafSettings('PilotageENDEL');
        //return ['ACH_OPERAT', 'ACH_FAMHA', 'CTRL_QUAL', 'ADMIN'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0;
    }
}
